import {
  getSummarySubTotals,
  usePricing,
} from '@customink/project-service-react-components';

import { LineItem } from './LineItem';

import { useFeatureFlagEnabled } from '@/hooks/FeatureFlags/useFeatureFlagEnabled';
import { useHasSignificantVolumeDiscount } from '@/hooks/Pricing';
import { useProjectTotalQuantity } from '@/hooks/Project';
import { VOLUME_DISCOUNT_FLAG_NAME } from '@/utils/featureFlags';

export function SubtotalLineItem() {
  const { data: pricingData, isLoading, isFetching } = usePricing();
  const hasSignificantVolumeDiscount = useHasSignificantVolumeDiscount();
  const quantity = useProjectTotalQuantity();
  const isVolumeDiscountEnabled = useFeatureFlagEnabled(
    VOLUME_DISCOUNT_FLAG_NAME,
  );

  const subTotalPrice = getSummarySubTotals(
    pricingData.grouped,
    'total_base_price',
  );
  const undiscountedSubTotalPrice = getSummarySubTotals(
    pricingData.grouped,
    'price_before_volume_discount',
  );

  const displayedSubTotalPrice =
    isVolumeDiscountEnabled && hasSignificantVolumeDiscount
      ? undiscountedSubTotalPrice
      : subTotalPrice;

  return (
    <LineItem
      isLoading={isLoading || isFetching}
      name={`Subtotal (${quantity} items)`}
      tagPrefix="subtotal"
      value={`$${displayedSubTotalPrice}`}
    />
  );
}
